import { PortableText } from '@portabletext/react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import imgFallback from 'src/utils/image';
import * as styles from './InnerCta.module.scss';
import ArrowIcon from 'src/svgs/arrow_forward.svg';

export const InnerCta = ({ title, description, image, link }) => (
  <div className={`mt-4 ${styles.card}`}>
    <div className={styles.image}>
      <GatsbyImage alt={image?.alt ?? ''} image={image?.image?.asset?.gatsbyImageData ?? imgFallback} />
    </div>
    <div className={styles.description}>
      <h3 className="h5 text-primary">{title}</h3>
      <PortableText value={description} />
      <Link to={link.url} className="btn btn-gradient-primary text-uppercase mt-3">
        <span className="mr-2">{link.title}</span>
        <ArrowIcon />
      </Link>
    </div>
  </div>
);

InnerCta.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  image: PropTypes.shape({}).isRequired,
  link: PropTypes.shape({}).isRequired,
};
